import * as openapi from "../../api";

class API {
    basicAuth?: string;

    private getConfig = (): openapi.Configuration => {
        const headers: { [index: string]: string } = {};
        const basePath = "/v1";
        if (this.basicAuth) {
            headers["Authorization"] = this.basicAuth;
        }
        return new openapi.Configuration({ basePath, headers });
    };

    public getAuthenticationApi = () => {
        return new openapi.AuthenticationApi(this.getConfig());
    };

    public getCommonAPI = () => {
        return new openapi.CommonApi(this.getConfig());
    };

    public getPaymentSummaryAPI = () => {
        return new openapi.PaymentsSummaryApi(this.getConfig());
    };

    public getCapacityAPI = () => {
        return new openapi.CapacityApi(this.getConfig());
    };

    public getShiftReportsAPI = () => {
        return new openapi.ShiftReportsApi(this.getConfig());
    };

    public getReserveApi = () => {
        return new openapi.ReserveApi(this.getConfig());
    }

    public getUsageTripAPI = () => {
        return new openapi.UsageTripApi(this.getConfig());
    };

    public getReleaseNoteAPI = () => {
        return new openapi.ReleaseNoteApi(this.getConfig());
    };

    public getWeeklyAPI = () => {
        return new openapi.WeeklyReportsApi(this.getConfig());
    };

    public getManualAPI = () => {
        return new openapi.ManualApi(this.getConfig());
    };

    setBasicAuth = (username: string, sessionKey: string) => {
        this.basicAuth = "Basic " + btoa(username + ":" + sessionKey);
    };
}

export const api = new API();
